import { useRef, useState } from "preact/hooks";
import { csvParse } from "d3-dsv";

// https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/file
function returnFileSize(number) {
  if (number < 1024) {
    return `${number} bytes`;
  } else if (number >= 1024 && number < 1048576) {
    return `${(number / 1024).toFixed(1)} KB`;
  } else if (number >= 1048576) {
    return `${(number / 1048576).toFixed(1)} MB`;
  }
}

const parseCsvFile = (text) =>
  csvParse(text, (row, _, columns) => {
    let total = 0;
    for (let i = 1; i < columns.length; ++i) {
      const columnName = columns[i];

      row[columnName] = +row[columnName];
      total += row[columnName];

      // TODO: use d3.fsum?
    }

    const firstKey = columns[0];
    row["angle"] = row[firstKey];
    row.total = total;
    delete row[firstKey];

    return row;
  });

const MiniDemoTable = () => (
  <table style="border: 1px solid silver">
    <thead>
      <tr>
        <th>angle</th>
        <th>Bin 1</th>
        <th>Bin 2</th>
        <th>Bin 3</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>N</td>
        <td>2</td>
        <td>5</td>
        <td>9</td>
      </tr>
      <tr>
        <td>E</td>
        <td>1</td>
        <td>3</td>
        <td>8</td>
      </tr>
      <tr>
        <td>S</td>
        <td>3</td>
        <td>7</td>
        <td>1</td>
      </tr>
      <tr>
        <td>W</td>
        <td>9</td>
        <td>5</td>
        <td>3</td>
      </tr>
    </tbody>
  </table>
);

const LoadFromFile = ({ onSetFileData, onConfirmFile }) => {
  const inputRef = useRef(null);
  const [csvFileInfo, setCsvFileInfo] = useState(null);

  const handleSubmit = async () => {
    const csvFile = inputRef.current.files[0];
    setCsvFileInfo(
      `${csvFile.name ? csvFile.name : "unnamedFile"} ${returnFileSize(
        csvFile.size
      )}`
    );

    const csvText = await csvFile.text();

    let csvData;
    try {
      csvData = parseCsvFile(csvText);
    } catch (err) {
      alert("Error. Could not read .csv file"); // TODO show modal instead
      console.warn("Could not read .csv file");
    }

    const bins = csvData.columns.slice(1);

    delete csvData.columns;
    onSetFileData({ bins, tableData: csvData });
  };

  return (
    <div class="define-data-card">
      <h2 class="h2">Load data from a csv file</h2>
      <p>
        The first column should contain the directions, its column header
        doesn't matter. The next columns should contain the data with bin names
        as column headers. The following table demonstrates the desired format.
        <MiniDemoTable />
      </p>
      <div class="select-file">
        <label class="select-file-label">
          <svg
            class="w-8 h-8"
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
          >
            <path d="M16.88 9.1A4 4 0 0 1 16 17H5a5 5 0 0 1-1-9.9V7a3 3 0 0 1 4.52-2.59A4.98 4.98 0 0 1 17 8c0 .38-.04.74-.12 1.1zM11 11h3l-4-4-4 4h3v3h2v-3z" />
          </svg>
          <span class="mt-2 text-base leading-normal">
            {csvFileInfo ? csvFileInfo : "Select a csv file"}
          </span>
          <input
            ref={inputRef}
            onInput={handleSubmit}
            type="file"
            class="hidden w-full h-full"
            title="Data is only stored locally on your machine, it is not transmitted to any server"
            accept=".csv"
          />
        </label>
      </div>
      <div class="flex justify-end pt-2">
        <button class="btn btn-blue inline-block" onClick={onConfirmFile}>
          Use this file
        </button>
      </div>
    </div>
  );
};

export { LoadFromFile };
